// ESM-Huelle fuer lib/scripts/components/CMP_CImage.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CImage (id)
{
    this.construct (id);

    this.name = "CImage";
    this.htmlType = "img";

    this.properties =
    {
        attributes: {},
        styles:
        {
            position: "absolute"
        }
    }
}

CImage.prototype = new CComponent;
export { CImage };
